import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageLayout } from 'src/components/shared/PageLayout';

export const NewspaperTopPageLayout: React.FC = ({ children }) => {
  const { t } = useTranslation(['newspaper', 'translation']);
  return (
    <PageLayout
      title={t('top')}
      color="#ffcd83"
      backLabel={t('translation:aria_button_back_to_previous')}
      background="#ffe7c2"
    >
      {children}
    </PageLayout>
  );
};
